export const getFullName = (user: unknown): string => {
  const userObj = user as { first_name?: string; last_name?: string };
  return `${userObj.first_name || ''} ${userObj.last_name || ''}`.trim();
};
